import { ConditionForm } from "~/components/form/health-profile/ConditionForm";
import { Authorize } from "~/components/permission/Authorize";
import { useDismiss } from "~/providers/DismissProvider";

export default function CreateCondition() {
    const { handleDismiss } = useDismiss();

    return (
        <Authorize ability="update" section="conditions">
            <ConditionForm onRequestClose={handleDismiss} asRoute />
        </Authorize>
    );
}
